import { makeStyles } from "@material-ui/core";

const timesheetValidateuseStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    fontSize: "12px",
    borderRadius: "8px !important",
    marginLeft: "1%",
     maxWidth: "95vw",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
  },
  tab: {
    width: "50%",
    color: "#1976d2",
    fontSize: "24px",
    fontWeight: "bold",
  },
  AppBar: {
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  },
  fieldset: {
     borderRadius: "10px",
    color: "#1976d2",
    fontSize: "20px",
    marginTop: "10px",
    overflowX: "auto", 
    padding: "10px",
    maxWidth: "94vw",
    width: "94vw",
     backgroundColor: "#ffffff",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.05)",
    border: "1px solid #d7e1f3",
    "& legend": {
      padding: "0 10px",
      color: "#2f5ca3",
      fontWeight: 700,
      letterSpacing: "0.2px",
    },
  },
  dialog: {
    width: "99%",
    height: "99%",
    justifyContent: "center",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    borderRadius: "20px",
    fontSize: "12px",
    background: "linear-gradient(180deg, #f7f9fc 0%, #ffffff 30%, #f7f9fc 100%)",
  },
  kmInputError: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#d32f2f !important",
        borderWidth: "1px",
      },
      "&:hover fieldset": {
        borderColor: "#d32f2f !important",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#d32f2f !important",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#d32f2f !important",
    },
    "& .MuiInputBase-input": {
      color: "#d32f2f",
    },
  },
  rightActions: {
    display: "flex !important",
    justifyContent: "flex-end !important",
    alignItems: "center",
    flexWrap: "nowrap",
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
    marginRight: "0 !important",
    gap: theme.spacing(1),
    "& .MuiButton-root": {
      flex: "0 0 auto",
      width: "auto",
      minWidth: "auto",
      whiteSpace: "nowrap",
    },
  },
   tdBordered: {
    textAlign: "center",
   borderLeft: "1px solid #c8c8c8ff",
  },
   tdBorderedRight: {
    textAlign: "center",
   borderRight: "1px solid #c8c8c8ff",
  }

}));

export default timesheetValidateuseStyles;
